import { useNavigate } from 'react-router-dom';
import { PaymentFailedModal } from '@/ui/molecules/PaymentFailedModal';
import { PaymentModal } from '@/ui/molecules/PaymentModal';
import { WalletConnectModal } from '@/ui/molecules/WalletConnectModal';
import { selectTopModal, useUIStore } from '@/store/ui';

export default function ModalHost() {
  const navigate = useNavigate();
  const topModal = useUIStore(selectTopModal);
  const popModal = useUIStore((s) => s.popModal);
  const pushModal = useUIStore((s) => s.pushModal);
  const clearModals = useUIStore((s) => s.clearModals);
  const setPaymentTxHash = useUIStore((s) => s.setPaymentTxHash);
  const txHash = useUIStore((s) => s.payment_tx_hash);

  return (
    <>
      <WalletConnectModal
        open={topModal === 'wallet_connect_modal'}
        onClose={popModal}
        onConnected={() => popModal()}
      />
      <PaymentModal
        open={topModal === 'payment_modal'}
        onClose={popModal}
        onFailed={(hash) => {
          setPaymentTxHash(hash ?? null);
          popModal();
          pushModal('payment_failed_error_modal');
        }}
      />
      <PaymentFailedModal
        open={topModal === 'payment_failed_error_modal'}
        txHash={txHash}
        onClose={() => {
          clearModals();
          navigate('/dashboard');
        }}
        onRetry={() => {
          popModal();
          pushModal('payment_modal');
        }}
      />
    </>
  );
}
